import styled, { css } from "styled-components";

const reusableBlocked = css`
  color: var(--red);
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  gap: 10px;
  pointer-events: none;
  cursor: not-allowed;

  .ant-tag {
    display: flex;
    width: max-content;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
`;

export const FooterButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* gap: 1em; */
  flex-flow: row nowrap;
  margin-top: 2em;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;

  button {
    height: 50px;
    border-radius: 0;
    font-weight: 600;
    font-size: 14px;

    svg {
      font-size: 18px;
    }
  }

  button.addbox {
    position: absolute;
    top: -30px;
    left: calc(50% - 32px);
    width: 65px;
    height: 65px;
    border-radius: 50%;
    border: 4px solid #fff;
    padding: 0;

    svg {
      font-size: 22px;
    }
  }

  button.bbtn.warn {
    background: #f0a8b5;
    color: #8c172a;

    &:disabled {
      background: #ccc;
      color: #000;
    }
  }
  button.bbtn.success {
    background: #90dfbe;
    color: #133e2c;

    &:disabled {
      background: #ccc;
      color: #000;
    }
  }
`;

export const MedBoxPicker = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 0.6em;
  background: #f5f5f5;
  border: 1px solid var(--accent);
  border-radius: 0.5em;
  overflow: hidden;
  margin: 2em 0 3em 0;
  .batchDetails {
    background: whitesmoke;
    color: #000;
    grid-column: 1/3;
    padding: 0.75em;
    text-align: center;
    font-weight: 600;
    font-size: 20px;
  }

  .batchDetails.blocked {
    ${reusableBlocked}
  }
  .medName {
    grid-column: 1/3;
    background: var(--accent-mid);
    color: var(--accent);
    padding: 0.75em;
    text-align: center;
    font-weight: 600;
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 10px;

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
    }

    span {
      font-size: 24px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      margin: -10px -10px;
    }
  }

  .issueReason {
    display: flex;
    align-items: center;
    color: #ff5f5f;
    font-weight: 500;
    padding-left: 10px;
    padding-bottom: 10px;
    grid-column: 1/3;
    justify-content: center;

    font-size: 14px;
  }

  p {
    background: #fff;
    padding: 0.75em 1em;
    margin: 0;
  }

  p.title {
    font-weight: 600;
    margin-top: -0.6em;
  }

  .batchList {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0.6em;
  }

  .batchList.blocked > p {
    ${reusableBlocked}
    justify-content: flex-start;
  }
`;

export const RackLocation = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 3em;
  position: relative;
  cursor: pointer;

  .issue {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    position: absolute;
    top: -15px;
    left: 50%;
    text-wrap: nowrap;
    transform: translate(-50%);
    background: var(--red-light);
    color: var(--red);
    padding: 5px 15px;
    border-radius: 50px;
    font-weight: 600;
  }

  div {
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  div:nth-child(1) {
    border-bottom: ${(props) =>
      props.bothLocationAvailable ? "1px solid #ccc" : "none"};
  }

  p {
    margin: 0;
    font-weight: 600;
  }
`;

export const MedBoxModalPicker = styled.div`
  width: 100%;
  /* display: grid;
  grid-template-columns: repeat(2, 1fr); */
  display: flex;
  flex-flow: row wrap;
  gap: 0.6em;
  background: #f5f5f5;
  border: 1px solid var(--accent);
  border-radius: 0.5em;
  overflow: hidden;

  .medName {
    /* grid-column: 1/3; */
    background: var(--accent-mid);
    color: var(--accent);
    padding: 0.75em;
    text-align: center;
    font-weight: 600;
    flex: 1 1 auto;
  }

  p {
    background: #fff;
    padding: 0.75em;
    margin: 0;
    width: 100%;
  }

  p.title {
    font-weight: 600;
    margin-top: -0.6em;
  }

  .addNewReason {
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    color: #2f65cb;
    cursor: pointer;
  }

  .batchList {
    display: flex;
    flex-flow: row wrap;
    gap: 5px;
    margin-bottom: 1em;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    & p:first-child {
      flex: 1 1 200px;
      font-weight: 600;
    }

    & p:nth-child(2) {
      font-weight: 600;
      flex: 1 1 10%;
    }

    & p:nth-child(3) {
      flex: 1 1 50%;
    }

    & p:last-child {
      flex: 1 1 150px;
    }
  }
`;

export const MedIssueModalWrapperPicker = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 1em;
`;
